import * as React from 'react';

function SvgTelegram(props) {
  return (
    <svg
      viewBox="0 -31 512 512"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M211 270l-40.918 43.676L181 390l120-90zm0 0" fill="#00c0f1" />
      <path d="M0 180l121 60 90 30 210 180L512 0zm0 0" fill="#76e2f8" />
      <path d="M121 240l60 150 30-120L421 90zm0 0" fill="#25d9f8" />
    </svg>
  );
}

export default SvgTelegram;
